import { render, staticRenderFns } from "./donor-communication-preferences.vue?vue&type=template&id=0491f2c7&scoped=true&"
import script from "./donor-communication-preferences.vue?vue&type=script&lang=js&"
export * from "./donor-communication-preferences.vue?vue&type=script&lang=js&"
import style0 from "./donor-communication-preferences.vue?vue&type=style&index=0&id=0491f2c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0491f2c7",
  null
  
)

export default component.exports